import React from "react";
import {typeUdnService} from "../jwt/_services";

export const typeUdnProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await typeUdnService.getAll();

        return listItems.map((itemData) => {
            const { id, name } = itemData
            return (
                {
                    id: id,
                    value: name,
                    label: <div><label>{name}</label></div>}
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}

async function getItem(id){
    try {
        const item = await typeUdnService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message);
    }
}